import React from 'react';
import {
  createTheme,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

interface FormSelectProps {
  label?: string;
  value?: string;
  onChange?: (event: SelectChangeEvent) => void;
  options: { value: string; label: string }[];
  required?: boolean;
  placeholder?: string;
  defaultValue?: string | null;
  disabled?: boolean;
  ariaLabel?: string;
  id?: string;
}

const ButtonDropDown: React.FC<FormSelectProps> = ({
  id,
  label,
  value,
  onChange,
  options,
  required = false,
  defaultValue,
  disabled,
  ariaLabel,
}) => {
  const labelId = label ? `${label.toLowerCase().replace(/\s+/g, '-')}-label` : undefined;
  const localTheme = createTheme({});

  const handleSelectChange: SelectProps['onChange'] = (event) => {
    onChange?.(event as SelectChangeEvent);
  };

  return (
    <ThemeProvider theme={localTheme}>
      <FormControl fullWidth className='button-drop-down'>
        {label && (
          <InputLabel disabled={disabled} /*shrink*/ id={labelId}>
            {label}
            {required && <span className='required'>*</span>}
          </InputLabel>
        )}
        <Select
          id={`${id ?? 'buttonDropDown'}Select`}
          variant='outlined'
          labelId={labelId}
          slotProps={{ input: { 'aria-labelledby': labelId } }}
          value={value}
          onChange={handleSelectChange}
          displayEmpty={false}
          disabled={disabled}
          defaultValue={defaultValue}
          label={required ? `${label}*` : label}
          aria-label={ariaLabel}
          //renderValue={value !== '' ? undefined : () => placeholder || label}
        >
          {options?.map((option) => (
            <MenuItem
              id={`${id ?? 'buttonDropDown'}OptionMenuItem_${option.value}`}
              key={option.value}
              value={String(option.value)}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </ThemeProvider>
  );
};

export default ButtonDropDown;
